import { DesignUploadMode } from 'swag-common/interfaces';
export const getVariantsInStockLevels = (product, variants, stockLevelsByVariantSku) => {
  const {
    hasSize,
    productSize,
    designUploadMode
  } = product;
  return variants.map(variant => {
    const {
      quantities
    } = variant;
    if (
    // @todo. auto generated. fix this error
    // @ts-ignore
    quantities.length > 1 && hasSize && productSize && designUploadMode !== DesignUploadMode.fullDesign) {
      return productSize.options.map(sizeLabel => {
        // @todo. auto generated. fix this error
        // @ts-ignore
        const productSku = variant.sizeSkus[sizeLabel];
        return stockLevelsByVariantSku[productSku];
      });
    } else {
      // @todo. auto generated. fix this error
      // @ts-ignore
      return stockLevelsByVariantSku[variant.productSku];
    }
  });
};